import React from "react";
import "./AlertPopUp.css";
import logo from "../../../assets/Nexum-Marchio.png";

interface AlertProps {
  message: React.ReactNode; // Cambia il tipo del messaggio in React.ReactNode
  onClose: () => void;
}

const Popup: React.FC<AlertProps> = ({ message, onClose }) => {
  const handleClick = () => {
    onClose();
  };

  return (
    <div className="alert-overlay">
      <div className="alert">
        <div className="alert-header">
          <img src={logo} alt="logo" className="imgAlert" />
        </div>
        <div className="alert-body">{message}</div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className="onCloseButton" onClick={handleClick}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
